<template>
    <div>
        <!-- Delete Confirmation Dialog -->
        <StationDeleteDialog
            :model-value="confirmDeleteDialog"
            @update:model-value="confirmDeleteDialog = $event"
            :station="station"
            @confirm="onConfirmDelete"
        />
        <v-layout row wrap mt-4 v-if="!isCard">
            <v-flex>
                <h1 class="heading grey--text text--darken-1">
                    <v-btn @click="$router.go(-1)" class="mr-2" depressed>
                        <v-icon large>mdi-arrow-left</v-icon>
                        <span>Back</span>
                    </v-btn>
                    {{ station.name }} Console
                </h1>
            </v-flex>
            <v-flex></v-flex>
            <v-flex mr-8 class="text-right" v-if="isCurrentUser">
                <v-btn class="mr-2 station-action-btn" @click="$emit('editView')" color="success">
                    <v-icon left>mdi-pencil</v-icon>
                    <span>Edit station</span>
                </v-btn>
                <StationOperate :station="station" />
                <template v-if="station.status === 1">
                    <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn class="mr-2 white--text station-action-btn" color="error"
                                    @click="confirmDeleteDialog = true" :disabled="true">
                                    <v-icon left>mdi-delete</v-icon>
                                    <span>Delete</span>
                                </v-btn>
                            </span>
                        </template>
                        <span>Only inactive stations can be deleted</span>
                    </v-tooltip>
                </template>
                <template v-else>
                    <v-btn class="mr-2 white--text station-action-btn" color="error" @click="confirmDeleteDialog = true"
                        :disabled="false">
                        <v-icon left>mdi-delete</v-icon>
                        <span>Delete</span>
                    </v-btn>
                </template>
            </v-flex>
        </v-layout>

        <StationCard v-else :station="station" />
    </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
import StationOperate from './StationOperate.vue'
import StationDeleteDialog from './StationDeleteDialog.vue'
import StationCard from './StationCard.vue'
import axios from '@/plugins/axios'

const props = defineProps({
  station: {
    type: Object,
    required: true
  },
  isCurrentUser: {
    type: Boolean,
    default: false
  },
  isCard: {
    type: Boolean,
    default: true
  }
})

const { station } = props

defineEmits(['editView', 'update:modelValue'])

const confirmDeleteDialog = ref(false)
const internalInstance = getCurrentInstance()
const router = internalInstance?.proxy?.$router


async function onConfirmDelete() {
  try {
    await axios.delete(`/v1/station/${station.id}`, {
      headers: {
        userId: localStorage.userId || station.userId || '',
        sessionToken: localStorage.sessionToken || ''
      }
    })
    // eslint-disable-next-line no-console
    console.log('Delete request sent for station:', station)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error deleting station:', error)
  }
  confirmDeleteDialog.value = false
  router.push(`/user/${localStorage.userId}`)
}

</script>

<style>
.station-action-btn {
  /* No effect on desktop, only mobile */
}
@media (max-width: 600px) {
  .station-action-btn {
    margin-bottom: 12px !important;
  }
}
</style>